import { createElement } from 'react';
import { bool, string, node, oneOfType, shape, number, arrayOf, object, oneOf } from 'prop-types';
import { withTheme } from 'reakit/styled';
import _get from 'lodash/get';
import './styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from './chunk-ad6ad343.js';
import propTypeUtils from 'airbnb-prop-types';
import parseIcons from './parseIcons.js';
import StyledIcon from './Icon/styled.js';

var Icon = function Icon(_ref) {
  var a11yHidden = _ref.a11yHidden,
      a11yLabel = _ref.a11yLabel,
      children = _ref.children,
      icon = _ref.icon,
      _size = _ref.size,
      theme = _ref.theme,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yHidden", "a11yLabel", "children", "icon", "size", "theme", "type"]);

  var size = _get(theme, "fannypack.fontSizes[" + (_size || '') + "]", 1);

  var newIcon = _get(theme, "fannypack.Icon.iconNames[" + icon + "]") || icon;

  var icons = _get(theme, "fannypack.Icon.icons", {}); // @ts-ignore


  var iconInfo = icons[newIcon];

  if (type) {
    // @ts-ignore
    var parsedIcons = parseIcons([icon], {
      type: type
    });
    iconInfo = Object.entries(parsedIcons)[0][1];
  } else if (typeof icon === 'object') {
    iconInfo = icon;
  }

  var _iconInfo = iconInfo,
      viewBoxWidth = _iconInfo.viewBoxWidth,
      viewBoxHeight = _iconInfo.viewBoxHeight,
      paths = _iconInfo.paths;
  return (// @ts-ignore
    createElement(StyledIcon, _extends({
      use: "svg",
      "aria-hidden": a11yHidden,
      role: "img" // @ts-ignore
      ,
      size: size,
      viewBox: "0 0 " + viewBoxWidth + " " + viewBoxHeight
    }, props), a11yLabel && createElement("title", null, a11yLabel), paths.map(function (path) {
      return createElement("path", {
        key: path,
        d: path,
        fill: "currentColor",
        fillRule: "evenodd"
      });
    }))
  );
};

var iconPropTypes = {
  a11yHidden: propTypeUtils.mutuallyExclusiveProps(bool, 'a11yHidden', 'a11yLabel'),
  // eslint-disable-line
  a11yLabel: propTypeUtils.mutuallyExclusiveProps(string, 'a11yHidden', 'a11yLabel'),
  // eslint-disable-line
  children: node,
  color: string,
  className: string,
  icon: oneOfType([string, shape({
    viewBoxHeight: number,
    viewBoxWidth: number,
    paths: arrayOf(string)
  })]),
  size: string,
  theme: object,
  // eslint-disable-line
  type: oneOf(['font-awesome', 'font-awesome-standalone'])
};
Icon.propTypes = iconPropTypes;
var iconDefaultProps = {
  children: null,
  className: undefined,
  color: undefined,
  icon: undefined,
  size: 'default',
  type: undefined
};
Icon.defaultProps = iconDefaultProps; // @ts-ignore

var C = withTheme(Icon);
export { C as a, iconPropTypes as b, iconDefaultProps as c };